export type FilterPropType<T> = null | undefined | T;

export interface IFilterValues {
    organizationIds?: FilterPropType<number[]>;
    salesPersonIds?: FilterPropType<number[]>;
    opportunityIds?: FilterPropType<number[]>;
    opportunityCreationDate?: {
        from: FilterPropType<Date>;
        to: FilterPropType<Date>;
        includeEmpty: FilterPropType<boolean>;
    };
    opportunityDueDate?: {
        from: FilterPropType<Date>;
        to: FilterPropType<Date>;
        includeEmpty: FilterPropType<boolean>;
    };
    projectStartDate?: { from: FilterPropType<Date>; to: FilterPropType<Date>; includeEmpty: FilterPropType<boolean> };
    projectEndDate?: { from: FilterPropType<Date>; to: FilterPropType<Date>; includeEmpty: FilterPropType<boolean> };
    markets?: FilterPropType<number[]>;
    leads?: FilterPropType<number[]>;
    divisionIds?: FilterPropType<number[]>;
    customerIds?: FilterPropType<number[]>;
    companyIds?: FilterPropType<number[]>;
    companyRoleIds?: FilterPropType<number[]>;
    productTypesIds?: FilterPropType<number[]>;
    bidCategoryIds?: FilterPropType<number[]>;
    potentialValue?: { from: FilterPropType<number>; to: FilterPropType<number> };
    probabilityValue?: { from: FilterPropType<number>; to: FilterPropType<number> };
    expectedResponseDate?: {
        from: FilterPropType<Date>;
        to: FilterPropType<Date>;
        includeEmpty: FilterPropType<boolean>;
    };
    bidDate?: { from: FilterPropType<Date>; to: FilterPropType<Date> };
    condition?: FilterPropType<boolean>;
    awardedAmount?: { from: FilterPropType<number>; to: FilterPropType<number> };
    bidAmount?: { from: FilterPropType<number>; to: FilterPropType<number> };
    stateId?: FilterPropType<number>;
    buildingClassId?: FilterPropType<number>;
    companyPropertyManagerIds?: FilterPropType<number[]>;
    companyTypeId?: FilterPropType<number>;
    legalStatusId?: FilterPropType<number>;
    awardedDate?: { from: FilterPropType<Date>; to: FilterPropType<Date> };
    includeOpportunityArchived?: FilterPropType<boolean>;
    estimateTypeId?: FilterPropType<number>;
    opportunityStatusIds?: FilterPropType<number[]>;
    competingBidderIds?: FilterPropType<number[]>;
    projectDueDate?: { from: FilterPropType<Date>; to: FilterPropType<Date> };
    projectStatusIds?: FilterPropType<number[]>;
    changeOrderStatusId?: FilterPropType<number>;
    changeOrderStatusIds?: FilterPropType<number[]>;
    projectIds?: FilterPropType<number[]>;
    accountIds?: FilterPropType<number[]>;
    relatedOpportunitiesSalesPersonIds?: FilterPropType<number[]>;
    includeArchived?: FilterPropType<boolean>;
    sellPriceValue?: { from: FilterPropType<number>; to: FilterPropType<number> };
}

export const DEFAULT_FILTER_VALUES: IFilterValues = {
    organizationIds: null,
    salesPersonIds: null,
    opportunityIds: null,
    opportunityCreationDate: { from: undefined, to: undefined, includeEmpty: undefined },
    opportunityDueDate: { from: undefined, to: undefined, includeEmpty: undefined },
    projectStartDate: { from: undefined, to: undefined, includeEmpty: undefined },
    projectEndDate: { from: undefined, to: undefined, includeEmpty: undefined },
    markets: null,
    leads: null,
    divisionIds: undefined,
    customerIds: null,
    companyIds: null,
    companyRoleIds: null,
    productTypesIds: null,
    bidCategoryIds: null,
    potentialValue: { from: undefined, to: undefined },
    probabilityValue: { from: undefined, to: undefined },
    expectedResponseDate: { from: undefined, to: undefined, includeEmpty: undefined },
    bidDate: { from: undefined, to: undefined },
    condition: undefined,
    awardedAmount: { from: undefined, to: undefined },
    bidAmount: { from: undefined, to: undefined },
    stateId: undefined,
    buildingClassId: undefined,
    companyPropertyManagerIds: null,
    companyTypeId: undefined,
    legalStatusId: undefined,
    awardedDate: { from: undefined, to: undefined },
    includeOpportunityArchived: false,
    estimateTypeId: undefined,
    opportunityStatusIds: null,
    competingBidderIds: null,
    projectDueDate: { from: undefined, to: undefined },
    projectStatusIds: null,
    changeOrderStatusId: null,
    changeOrderStatusIds: null,
    projectIds: null,
    accountIds: null,
    relatedOpportunitiesSalesPersonIds: null,
    includeArchived: undefined,
    sellPriceValue: { from: undefined, to: undefined }
};
